// NPM MODULES
import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';

import Loader from '../../common/Loader';

// NETWORKING
import useMessageReportRequest from '../../../requests/MessageReportRequest';

// FORMATTED MESSAGES
import MessageReportsFormattedMessages from '../../../messages/reports/MessageReportsFormattedMessages';

const MessageReportSingle = ({ selected, errorHandler }) => {
  const [smsData, setSmsData] = useState({});
  const [loading, setLoading] = useState(true);
  const { getSingleMessageData } = useMessageReportRequest();

  useEffect(() => {
    const loadSmsData = async () => {
      try {
        const data = await getSingleMessageData(selected.smsId, errorHandler);
        setSmsData(data);
      } catch (error) {
        console.error('Error loading SMS data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSmsData();
  }, []);

  const deliverDate = smsData.sms_delivered
    ? DateTime.fromISO(smsData.sms_delivered).setZone(
        localStorage.getItem('timeShort'),
        { keepLocalTime: false }
      )
    : 'Pending Delivery';

  const sentDate = DateTime.fromISO(smsData.sms_sent);
  const rezoned = sentDate.setZone(localStorage.getItem('timeShort'), {
    keepLocalTime: false,
  });

  let delay = 'N/A';
  if (smsData.sms_delivered && smsData.sms_sent) {
    delay =
      new Date(smsData.sms_delivered).getTime() -
      new Date(smsData.sms_sent).getTime() +
      ' (ms)';
  }

  let smsText;
  try {
    smsText = smsData.sms_text ? decodeURIComponent(smsData.sms_text) : 'N/A';
  } catch (err) {
    smsText = 'ERROR: MALFORMED TEXT';
  }

  if (loading) {
    return <Loader />;
  }

  if (!smsData) {
    return <Typography>No Data</Typography>;
  }

  return (
    <Box>
      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.smsQueued}
      </Typography>
      <Typography gutterBottom>
        {`${rezoned.toFormat('dd-LLL-yyyy h:mm a')} ${localStorage.getItem(
          'timeString'
        )}`}
      </Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.smsDelivered}
      </Typography>
      <Typography gutterBottom>
        {smsData.sms_delivered
          ? deliverDate.toFormat('dd-LLL-yyyy h:mm a')
          : 'Pending Delivery'}
      </Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.delay}
      </Typography>
      <Typography gutterBottom>{delay}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.destination}
      </Typography>
      <Typography gutterBottom>{smsData.dest_tn || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.countryText}
      </Typography>
      <Typography gutterBottom>{smsData.country_code_name || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.originator}
      </Typography>
      <Typography gutterBottom>{smsData.originator || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.typeText}
      </Typography>
      <Typography gutterBottom>{smsData.smsType || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.statusText}
      </Typography>
      <Typography gutterBottom>{smsData.status || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.userText}
      </Typography>
      <Typography gutterBottom>{smsData.userEmail || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.campaignId}
      </Typography>
      <Typography gutterBottom>{smsData.campaignId || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.encoding}
      </Typography>
      <Typography gutterBottom>{smsData.smsc_params || 'N/A'}</Typography>

      <Typography fontWeight={700}>
        {MessageReportsFormattedMessages.messageParts}
      </Typography>
      <Typography gutterBottom>{smsData.no_of_sms_sent || 'N/A'}</Typography>

      {smsData.errorCode && (
        <>
          <Typography fontWeight={700}>
            {MessageReportsFormattedMessages.errorText}
          </Typography>
          <Typography gutterBottom>{smsData.errorCode}</Typography>
        </>
      )}

      {smsData.sms_text && (
        <>
          <Typography fontWeight={700}>Message</Typography>
          <Typography gutterBottom>{smsText}</Typography>
        </>
      )}
    </Box>
  );
};

export default MessageReportSingle;
